import { channelsSlice } from "./reducer";

export const {
  channelsFetchLoadingStart,
  channelsFetchLoadingSuccess,
  channelsFetchLoadingFail,
  channelsReset,
} = channelsSlice.actions;
